// extracted by mini-css-extract-plugin
export default {"container":"vkRPJL_Q","timetableWrapper":"ArV6IRie scrollable","modulesSelect":"tSNnD21v col-12","moduleTableFooter":"ZfLPtFn7"};